import { render, staticRenderFns } from "./StateViewerWallet.vue?vue&type=template&id=1aa839d4"
import script from "./StateViewerWallet.vue?vue&type=script&lang=js"
export * from "./StateViewerWallet.vue?vue&type=script&lang=js"
import style0 from "./StateViewerWallet.vue?vue&type=style&index=0&id=1aa839d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports